import Axios from 'axios';

let instance = Axios.create({
    timeout: 30000,
    withCredentials: false,
    maxContentLength: 128 * 1024 * 1024,
});

instance.setData = (token, baseURL, headers) => {
    instance.defaults.headers = { ...instance.defaults.headers, ...headers };
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
    instance.defaults.baseURL = baseURL;
};

instance.setInstance = (axiosInstance) => {
    // Soft copy
    Object.keys(axiosInstance).forEach((key) => (instance[key] = axiosInstance[key]));
};

export default instance;
